import { useCallback, useEffect, useState } from "react"

import {
  getPinLockoutDelayMs,
  getPinLockoutSecondsRemaining,
} from "#utils/pinLockoutHelpers"

import useLocalStorage, { getJarvisLocalStorage } from "./useLocalStorage"

const usePinLockout = () => {
  const [settings, updateSettings] = useLocalStorage()
  const [secondsRemaining, setSecondsRemaining] = useState(() =>
    getPinLockoutSecondsRemaining(settings.pinLockoutUntilMs)
  )

  const pinLockoutUntilMs = settings.pinLockoutUntilMs

  useEffect(() => {
    const tick = () => {
      setSecondsRemaining(getPinLockoutSecondsRemaining(pinLockoutUntilMs))
    }

    tick()
    const intervalId = setInterval(tick, 250)

    return () => {
      clearInterval(intervalId)
    }
  }, [pinLockoutUntilMs])

  const isLockedOut = secondsRemaining > 0

  const recordFailedAttempt = useCallback(() => {
    const currentSettings = getJarvisLocalStorage()
    const failedPinLoginAttempts = currentSettings.failedPinLoginAttempts + 1
    const delayMs = getPinLockoutDelayMs(failedPinLoginAttempts)
    const nextLockoutUntilMs =
      delayMs > 0 ? Date.now() + delayMs : currentSettings.pinLockoutUntilMs

    updateSettings({
      failedPinLoginAttempts,
      pinLockoutUntilMs: nextLockoutUntilMs,
    })
  }, [updateSettings])

  const clearLockout = useCallback(() => {
    updateSettings({
      failedPinLoginAttempts: 0,
      pinLockoutUntilMs: 0,
    })
  }, [updateSettings])

  return {
    isLockedOut,
    secondsRemaining,
    recordFailedAttempt,
    clearLockout,
  }
}

export default usePinLockout
